import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';

export default function Disclaimer() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <Navigation />

      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Safety & Disclaimer</h1>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Important information about using SayItBetter safely and responsibly
            </p>
          </div>

          {/* Important Notice */}
          <div className="bg-yellow-50 border-2 border-yellow-300 rounded-2xl p-8 mb-8">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-yellow-400 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-alert-line text-2xl text-yellow-900"></i>
              </div>
              <div>
                <h2 className="text-xl font-bold text-yellow-900 mb-3">Important Notice</h2>
                <p className="text-sm text-yellow-900 leading-relaxed">
                  SayItBetter is an educational tool designed to help teens develop healthy communication skills. It is <strong>not a substitute for professional therapy, counseling, or medical advice</strong>. If you or someone you know is in crisis or experiencing an emergency, please contact emergency services or a crisis helpline immediately.
                </p>
              </div>
            </div>
          </div>

          {/* What SayItBetter Is */}
          <div className="bg-white rounded-2xl shadow-sm p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">What SayItBetter Is</h2>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-xl text-green-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">An educational tool to help teens understand message tone and intent</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-xl text-green-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">A resource for learning healthy communication skills</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-xl text-green-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">A guide for crafting respectful, boundary-setting responses</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-check-line text-xl text-green-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">A tool to help identify potential red flags in communication</span>
              </li>
            </ul>
          </div>

          {/* What SayItBetter Is Not */}
          <div className="bg-white rounded-2xl shadow-sm p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">What SayItBetter Is NOT</h2>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-close-line text-xl text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">A replacement for professional therapy or counseling</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-close-line text-xl text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">A crisis intervention or emergency response service</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-close-line text-xl text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">A substitute for talking to trusted adults about serious concerns</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-close-line text-xl text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">A monitoring or surveillance tool for parents</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-close-line text-xl text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">Legal advice or a legal service</span>
              </li>
            </ul>
          </div>

          {/* Limitations */}
          <div className="bg-white rounded-2xl shadow-sm p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Limitations of AI Analysis</h2>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              While our AI is designed to provide helpful insights, it has limitations:
            </p>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-arrow-right-s-line text-lg text-gray-400 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">AI cannot fully understand context, relationships, or personal history</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-arrow-right-s-line text-lg text-gray-400 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">Analysis may not always be 100% accurate or appropriate for every situation</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-arrow-right-s-line text-lg text-gray-400 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">Reply suggestions are general guidance, not personalized advice</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-arrow-right-s-line text-lg text-gray-400 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">You should always use your own judgment and consider your specific situation</span>
              </li>
            </ul>
          </div>

          {/* When to Seek Help */}
          <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-8 mb-8">
            <h2 className="text-2xl font-bold text-red-900 mb-6">When to Seek Professional Help</h2>
            <p className="text-sm text-red-900 mb-4 leading-relaxed">
              Please reach out to a trusted adult, counselor, or crisis helpline if you experience:
            </p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start space-x-3">
                <i className="ri-alert-line text-lg text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-red-900">Threats of violence or harm to yourself or others</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-alert-line text-lg text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-red-900">Requests for explicit photos or sexual content</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-alert-line text-lg text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-red-900">Persistent harassment, bullying, or stalking behavior</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-alert-line text-lg text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-red-900">Pressure to keep secrets from parents or trusted adults</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-alert-line text-lg text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-red-900">Feelings of depression, anxiety, or thoughts of self-harm</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-alert-line text-lg text-red-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-red-900">Any situation that makes you feel unsafe or extremely uncomfortable</span>
              </li>
            </ul>
            <p className="text-sm text-red-900 font-semibold">
              Remember: It's always better to tell a trusted adult than to handle serious situations alone.
            </p>
          </div>

          {/* Crisis Resources */}
          <div className="bg-white rounded-2xl shadow-sm p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Crisis Resources</h2>
            <p className="text-sm text-gray-700 mb-6">
              If you need immediate help, please contact one of these resources:
            </p>
            <div className="space-y-4">
              <div className="bg-blue-50 rounded-xl p-4">
                <h3 className="text-base font-semibold text-gray-900 mb-2">Crisis Text Line</h3>
                <p className="text-sm text-gray-700 mb-2">Free, 24/7 support for people in crisis</p>
                <p className="text-base font-bold text-blue-600">Text HOME to 741741</p>
              </div>
              <div className="bg-blue-50 rounded-xl p-4">
                <h3 className="text-base font-semibold text-gray-900 mb-2">National Suicide Prevention Lifeline</h3>
                <p className="text-sm text-gray-700 mb-2">Free, confidential support 24/7</p>
                <p className="text-base font-bold text-blue-600">Call 988 or 1-800-273-8255</p>
              </div>
              <div className="bg-blue-50 rounded-xl p-4">
                <h3 className="text-base font-semibold text-gray-900 mb-2">Love is Respect</h3>
                <p className="text-sm text-gray-700 mb-2">Support for teen dating abuse and unhealthy relationships</p>
                <p className="text-base font-bold text-blue-600">Text LOVEIS to 22522 or call 1-866-331-9474</p>
              </div>
              <div className="bg-blue-50 rounded-xl p-4">
                <h3 className="text-base font-semibold text-gray-900 mb-2">RAINN (Rape, Abuse & Incest National Network)</h3>
                <p className="text-sm text-gray-700 mb-2">Support for sexual assault survivors</p>
                <p className="text-base font-bold text-blue-600">Call 1-800-656-4673</p>
              </div>
              <div className="bg-blue-50 rounded-xl p-4">
                <h3 className="text-base font-semibold text-gray-900 mb-2">Cyberbullying Research Center</h3>
                <p className="text-sm text-gray-700 mb-2">Resources for cyberbullying victims</p>
                <p className="text-base font-bold text-blue-600">Visit cyberbullying.org</p>
              </div>
            </div>
          </div>

          {/* Privacy & Data */}
          <div className="bg-white rounded-2xl shadow-sm p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Privacy & Data Protection</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-base font-semibold text-gray-900 mb-2">Message Privacy</h3>
                <p className="text-sm text-gray-700">
                  Messages you analyze are processed in real-time and are not stored on our servers. We do not save, share, or use your messages for any purpose beyond providing immediate analysis.
                </p>
              </div>
              <div>
                <h3 className="text-base font-semibold text-gray-900 mb-2">Usage Data</h3>
                <p className="text-sm text-gray-700">
                  We may collect anonymous usage statistics (like number of analyses performed) to improve our service, but this data cannot be linked to individual users or specific messages.
                </p>
              </div>
              <div>
                <h3 className="text-base font-semibold text-gray-900 mb-2">Age Requirements</h3>
                <p className="text-sm text-gray-700">
                  SayItBetter is designed for users ages 13-18. Users under 13 should not use this service. We recommend parental involvement for all teen users.
                </p>
              </div>
            </div>
          </div>

          {/* User Responsibility */}
          <div className="bg-white rounded-2xl shadow-sm p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">User Responsibility</h2>
            <p className="text-sm text-gray-700 mb-4">By using SayItBetter, you agree to:</p>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-lg text-blue-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">Use the service for educational purposes only</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-lg text-blue-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">Exercise your own judgment when applying suggestions</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-lg text-blue-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">Seek help from trusted adults for serious concerns</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-lg text-blue-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">Not use the service to harm, manipulate, or deceive others</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-line text-lg text-blue-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">Understand that AI analysis has limitations</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-8 text-center">
            <h2 className="text-2xl font-bold text-white mb-4">Questions About Safety?</h2>
            <p className="text-base text-blue-100 mb-6 max-w-2xl mx-auto">
              If you have questions or concerns about safety, privacy, or how to use SayItBetter responsibly, we're here to help.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/parent-info" className="px-6 py-3 bg-white text-blue-600 text-sm font-semibold rounded-full hover:bg-blue-50 transition-colors whitespace-nowrap">
                Parent Information
              </Link>
              <a href="mailto:safety@sayitbetter.com" className="px-6 py-3 bg-blue-800 text-white text-sm font-semibold rounded-full hover:bg-blue-900 transition-colors whitespace-nowrap">
                Contact Safety Team
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
